/* @flow */
import React from 'react';

import cx from 'classnames';

import './styles/SettingsContainer.scss';

class SettingsContainer extends React.Component {
  render() {
    return (
      <div
        {...this.props}
        className={cx('SettingsContainer', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default SettingsContainer;



// WEBPACK FOOTER //
// ./src/settings/components/SettingsContainer.jsx